import { render, staticRenderFns } from "./AirControl.vue?vue&type=template&id=9020ef06&scoped=true"
import script from "./AirControl.vue?vue&type=script&lang=js"
export * from "./AirControl.vue?vue&type=script&lang=js"
import style0 from "./AirControl.vue?vue&type=style&index=0&id=9020ef06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9020ef06",
  null
  
)

export default component.exports